import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import FileLockedIcon from 'icons/FileLocked.icon';
import DownloadIcon from 'icons/Download.icon';
import DownloadCloudIcon from 'icons/DownloadCloud.icon';
import DesktopAppContext from 'router/subrouters/DataRoom/providers/DesktopApp/DesktopApp.context';
import { DOWNLOAD_SOURCE } from 'models/MixpanelEvents';
import useStartDownloadingFile from 'hooks/useStartDownloadingFile';

import './LockedFilePreview.styles.scss';

type LockedFilePreviewProps = {
  className?: string;
  nodeId: string;
  documentName?: string;
  dataRoomId?: string;
  dataRoomName?: string;
};

const LockedFilePreview: React.FC<LockedFilePreviewProps> = (props) => {
  const { className, nodeId, documentName, dataRoomId, dataRoomName } = props;

  const { downloadLink, trackDownload } = useContext(DesktopAppContext);

  const startDownloadingFile = useStartDownloadingFile();

  const classes = classNames('locked-file-preview', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <FileLockedIcon />
      <p>
        {documentName
          ? t('previewUnavailableWithFileName', { fileName: documentName })
          : t('previewUnavailable')}
      </p>
      <p>
        {t(
          downloadLink
            ? 'previewUnavailableMaximumSecurityDescription'
            : 'previewUnavailableMaximumSecurityDescriptionWithoutDownload',
        )}
      </p>

      <div className="actions">
        {downloadLink && (
          <a
            className="ncoded-button ncoded-button--outline"
            href={downloadLink}
            onClick={() =>
              trackDownload(
                DOWNLOAD_SOURCE.FILE_POPUP,
                dataRoomId,
                dataRoomName,
              )
            }
          >
            <DownloadCloudIcon />
            {t('downloadResolveApp')}
          </a>
        )}

        <Button
          icon={DownloadIcon}
          onClick={() => startDownloadingFile(nodeId)}
        >
          {t('downloadFile')}
        </Button>
      </div>
    </div>
  );
};

export default LockedFilePreview;
